/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { password_check } from './password_check';
import 'select2';

require('./bootstrap');

require('./_tracking');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
$('.show-password').on('click', function () {
    let ct = $('.' + $(this).data('target'));
    let field = $('input[name=' + $(this).data('field') + ']');

    $(this).hide();
    ct.find('.hide-password').show();
    field.attr('type', 'text');
});

$('.hide-password').on('click', function () {
    let ct = $('.' + $(this).data('target'));
    let field = $('input[name=' + $(this).data('field') + ']');

    $(this).hide();
    ct.find('.show-password').show();
    field.attr('type', 'password');
});

$('#password-input').ready(function () {
    $('#password-input').strengthMeter('progressBar', {
        container: $('#password-strength-container'),
        hierarchy: {
            0: 'progress-bar-danger',
            25: 'progress-bar-warning',
            75: 'progress-bar-success',
        },
    });
});

$('.datatable').DataTable({
    order: [[0, 'desc']],
    info: false,
    paging: false,
    searching: false,
    scrollX: true,
    columnDefs: [
        {
            targets: $('.datatable th td').length - 1, // Actionrow!
            orderable: false,
        },
    ],
});

$('.customer-number-autocomplete').each(function () {
    $(this).select2({
        minimumInputLength: 2,
        placeholder: 'Please chose company ...',

        allowClear: true,
        ajax: {
            dataType: 'json',
            type: 'GET',
            url: $(this).data('action'),
        },
    });
});

$('.nav-link').on('click', function () {
    $('.sidebar-collapse').removeClass('sidebar-collapse');
});

password_check();
